export default ({
  pageState: { editorAdders, editorBlocks, editorBlocksOrder },
  data: { blockType, defaultData, localBlockId, missingTranslations, position }
}) => {
  return {
    editorAdders: [...editorAdders.map(() => false), false],
    editorBlocks: {
      ...editorBlocks,
      [localBlockId]: {
        data: defaultData,
        isNew: true,
        missingTranslations,
        type: blockType
      }
    },
    editorBlocksOrder: [
      ...editorBlocksOrder.slice(0, position),
      localBlockId,
      ...editorBlocksOrder.slice(position)
    ],
    editorHeaderStatus: 'saving'
  };
};
